import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { PipesModule } from '../../../pipes';
import { ExtendedDetailedStockInfoComponent } from './extended-detailed-stock-info.component';

@NgModule({
  declarations: [ExtendedDetailedStockInfoComponent],
  imports: [CommonModule, I18nModule, PipesModule, NzIconModule],
  exports: [ExtendedDetailedStockInfoComponent],
})
export class ExtendedDetailedStockInfoModule {}
